import type React from 'react'

import { useSearch } from '@tanstack/react-router'

import { ConfigurationHistoryPage } from './ConfigurationHistoryPage'
import { StatsPage } from './StatsPage'

export const StatsPageRouter: React.FC = () => {
  const { section = 'requests' } = useSearch({ from: '/stats/' })

  if (section === 'configuration') {
    return <ConfigurationHistoryPage />
  }

  return <StatsPage />
}
